/* eslint-disable formatjs/no-literal-string-in-jsx */
import { trackPageView } from '@snowplow/browser-tracker'
import { TechnicalErrorStep } from '@ui-components/layout/TechnicalErrorStep'
import { TertiaryHeading } from '@ui-components/typography/headings/TertiaryHeading'
import { Component, ReactNode } from 'react'
import { createGlobalStyle, styled } from 'styled-components'

import { sendErrorEventToAnalytics } from '../analytics'
import { reloadState } from '../utils/lazyReload'

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
  }
`

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
}

const Centered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export class AppErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
  }

  static getDerivedStateFromError(): State {
    if (reloadState.isReloading) {
      return { hasError: false }
    }

    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: unknown): void {
    console.error('Uncaught error:', error, errorInfo)

    trackPageView({ title: 'AppErrorBoundary' })
    sendErrorEventToAnalytics(`App error: ${error.message}`, error)
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <>
          <GlobalStyle />
          <TechnicalErrorStep
            heading={
              <Centered>
                <TertiaryHeading header="Odottamaton tekninen virhe" tagName="h2" />
                <TertiaryHeading header="Oförutsett tekniskt fel" tagName="h2" />
              </Centered>
            }
            content={
              <Centered>
                <p>Yritä myöhemmin uudelleen tai ota yhteyttä asiakaspalveluun.</p>
                <p>Försök senare på nytt eller kontakta kundtjänsten.</p>
              </Centered>
            }
            buttonLabel="Lataa uudelleen / Ladda om"
            onButtonClick={() => {
              if (sessionStorage) {
                sessionStorage.clear()
              }
              location.reload()
            }}
          />
        </>
      )
    }
    return this.props.children
  }
}
